/**
    品牌列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }" class="jj"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ info.name }}</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 置顶导航栏 开始 -->
    <div
      :class="searchBarFixed == true ? 'pro-fixed-div' : 'pro-fixed_none'"
      id="searchBar"
    >
      <el-row style="width: 1200px">
        <el-col :span="4"
          ><div class="topNav_shopName">{{ storeInfo.name }}</div></el-col
        >
        <el-col :span="20">
          <ul class="toNav_goodsInfo">
            <li
              v-for="(item, index) in topNav"
              :key="item.id"
              class="toNav_goodsInfoItem"
              @click="topNavClick(item.id, index)"
              :class="isSelectedTab == index ? 'activeTab' : ''"
            >
              <div>
                {{ item.title }}
                <i v-if="item.id == 1"> ( {{ commentLength }} ) </i>
                <i v-if="item.id == 2"> ( {{ adviceLength }} ) </i>
              </div>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <!-- 置顶导航栏  结束-->

    <el-row style="margin-bottom: 20px">
      <el-col :span="8">
        <div class="fl">
          <!-- <div class="fl second-img" @mouseover="bigImgMove()" id="secondimg"> -->
          <div class="fl second-img" id="secondimg">
            <magnifier :qall="bigphotos" :qallBig="bigphotos" :videoUrl='videoUrl' :isVedio='isVedio'></magnifier>
            <!-- <div id="smallBox">
						<ul class="smallimg fl" >
							<li>
								<el-image id="smallBox_img" :src="`${info.photos}`" alt="picture"></el-image>
							</li>
						</ul>
						<div class="left-arr" id="left-arr"></div>
						<div class="right-arr" id="right-arr"></div>
						<div class="fangdj fl" id="mask"></div>
					</div>
					<div class="bigbox" id="bigbox">
						<img id="bigBox_img" src="https://www.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200723/1595488198898831.jpg!800x800.jpg" alt="">
					</div> -->
          </div>
          <div class="smallnav">
            <ul class="smnav" id="smnav">
              <li
                @click="selectedImg(item, index)"
                v-for="(item, index) in moreImgArr"
                :key="item"
                :class="isSelectedImg == index ? 'active' : ''"
              >
               <el-image v-if="item.indexOf('mp4')>0||item.indexOf('avi')>0||item.indexOf('dat')>0||item.indexOf('3gp')>0||item.indexOf('mov')>0||item.indexOf('rmvb')>0" :src="`${item}`" alt="" class="bg playBg">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-video-play"></i>
                    </div>
                </el-image>
                 <el-image :src="`${item}`" alt="" class="bg">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                  </el-image>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="fr second-detail">
          <p class="dettitle">{{ info.name }}</p>
          <p class="tagadWord">{{ info.adWord }}</p>
          <p class="tag">{{ info.tag }}</p>
          <!-- <p class="detprice"> ¥149 &nbsp;<i>¥179</i></p> -->
          <div class="introduce">
            <div v-if="isSupplier == 0 || isSupplier == 1 ? false : true">
              <div class="ks clearfix">
                <div class="kuanshi fl">批发价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <!-- marketprice 需要乘以折扣 -->
                  <span class="dettitle">¥{{ info.realprice }}</span>
                  <!-- <span class="dettitle">¥{{info.marketprice}}</span> -->
                </div>
              </div>
              <div class="ks clearfix">
                <div class="kuanshi fl">市场价 :</div>
                <div class="kuanshi-two fl kuanshi-two1">
                  <span class="marketPrice_text">¥{{ info.marketprice }}</span>
                </div>
              </div>
            </div>
            <div
              class="closePrice_box"
              v-if="isSupplier == 0 || isSupplier == 1 ? true : false"
            >
              <el-row>
                <el-col :span="3">
                  <div class="kuanshi fl closePrice_title">批发价 :</div>
                  <div class="kuanshi fl">市场价 :</div>
                </el-col>
                <el-col :span="20">
                  <div class="closePrice">申请成为分销商后可查看商品价格</div>
                </el-col>
              </el-row>
              <!-- <div class=" ks clearfix">
                    <div class="kuanshi fl">商城价 :</div>
                    <div class="kuanshi-two fl kuanshi-two1" >
                        <span class="dettitle">¥{{info.marketprice}}</span> 降价通知
                    </div>
                </div>
                <div class=" ks clearfix">
                  <div class="kuanshi fl">市场价 :</div>
                  <div class="kuanshi-two fl kuanshi-two1" >
                      <span>¥{{info.price}}</span>
                  </div>
                </div> -->
            </div>
            <!-- 地址后期开放 -->
            <div class="ks clearfix">
              <!-- <div class="kuanshi fl">配送 :</div>
                <div class="kuanshi-two fl kuanshi-two1" >
                    <el-cascader
                        v-model="cascaderAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="发货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader>
                    至
                     <el-cascader
                        v-model="shippingAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="收货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader>
                </div> -->
            </div>
            <!-- <div class=" ks clearfix">
                <div class="kuanshi fl">服务 :</div>
                <div class="kuanshi-two fl kuanshi-two1" >
                    由 <a href=""> 本网站 </a> 发货并提供售后服务 [ 快递：¥4.30 ]
                </div>
            </div> -->
            <!-- <div class=" ks clearfix">
                  <div class="kuanshi fl">红包 :</div>
                  <div class="kuanshi-two fl kuanshi-two1" >
                                  可用0个
                  </div>
            </div> -->
            <!-- <div class=" ks clearfix">
              <div class="kuanshi fl">规格 :</div>
              <div class="kuanshi-two fl kuanshi-two2">
                              <el-radio-group v-model="goodsSize" size="medium" >
                                  <el-radio border :label="item.bXySid" @change="getgoodsSize(item.realprice,item.bXySid)" v-for="(item,index) in info.specificationlist" :key="index">{{item.name}}</el-radio>

                              </el-radio-group>
              </div>
              <span class="select_c" id="select_c"><i></i>&nbsp;请输入选择材质</span>
            </div> -->
            <!-- 商品规格 -->
            <div
              class="ks clearfix"
              v-for="(item1, index) in attributelist"
              :key="index"
            >
              <goodsSizeItem
                :attributelist="item1"
                :goodsIdArr="goodsIdArr"
                :getgoodsSize="getgoodsSize"
              ></goodsSizeItem>
            </div>
            <div class="ks clearfix">
              <div class="kuanshi fl">数量 :</div>
              <div class="number fl">
                <el-input-number
                  v-model="info.number"
                  @change="handleChange"
                  :min="1"
                  :max="info.stock"
                  label="描述文字"
                ></el-input-number>
              </div>
            </div>

            <!-- <div class="buygoods">
						<router-link href="javascript:;" class="rightnow2 fl" id="rightnow2" to="/orderDetail">立即购买</router-link>
						<a href="javascript:;" style="color:white" class="addcar2 fl" id="addcar2"
               @click="onAddCar(info.id,info.number,info.bXySid)"
            >
              <i class="addshopcar"></i>加入购物车</a>
					</div> -->

            <!-- 一键分销 未申请 -->
            <div
              class="buygoods"
              v-if="isSupplier == 0 || isSupplier == 1 ? true : false"
            >
              <a
                href="javascript:;"
                class="rightnow2 fl"
                id="rightnow2"
                @click="becomeSupplier"
                >申请成为分销商</a
              >
            </div>

            <!-- 一键分销 已申请 -->
            <div
              class="buygoods"
              v-if="isSupplier == 2 || isSupplier == 4 ? true : false"
            >
              <a
                href="javascript:;"
                class="rightnow2 fl"
                id="rightnow2"
                @click="oneClickDistribution"
                >一键分销</a
              >
              <a
                href="javascript:;"
                style="color: white"
                class="addcar2 fl"
                id="addcar2"
                @click="
                  onAddCar(
                    info.id,
                    info.number,
                    info.bXySid,
                    info.status,
                    info.approvalStatus
                  )
                "
              >
                <i class="addshopcar"></i>加入购物车</a
              >
            </div>

            <!-- 已分销 正常购买 -->
            <div class="buygoods" v-if="isSupplier == 5 ? true : false">
              <a
                href="javascript:;"
                class="rightnow2 fl"
                id="rightnow2"
                @click="orderNow(info.status, info.approvalStatus)"
                >立即购买</a
              >
              <a
                href="javascript:;"
                style="color: white"
                class="addcar2 fl"
                id="addcar2"
                @click="
                  onAddCar(
                    info.id,
                    info.number,
                    info.bXySid,
                    info.status,
                    info.approvalStatus
                  )
                "
              >
                <i class="addshopcar"></i>加入购物车</a
              >
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="twoButtom">
      <el-button
        @click="addCollectionHandle(info.id)"
        v-if="info.isCollect == 0 ? true : false"
        size="mini"
        icon="el-icon-star-off"
        >收藏</el-button
      >
      <el-button
        @click="removeCollectionHandle(info.id)"
        v-if="info.isCollect == 1 ? true : false"
        size="mini"
        icon="el-icon-star-on"
        >已收藏</el-button
      >
    </el-row>
    <el-row>
      <el-col :span="4">
        <shopStoreItem :shopInfo="storeInfo" :isshow="1"></shopStoreItem>
        <hotGoods
          :navTitle="hotGoodsTitle"
          :hotGoodsList="lefthotGoodsList"
        ></hotGoods>
      </el-col>
      <el-col :span="20">
        <el-tabs
          v-model="activeName"
          @tab-click="tabhandleClick"
          class="goodsTabsr_card"
          type="border-card"
        >
          <el-tab-pane name="0">
            <span slot="label" class="goodsTabs">商品详情</span>
            <div class="goods_advisory">
              <div v-html="info.description"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="1">
            <span slot="label" class="goodsTabs">
              商品评价 <i> ( {{ commentLength }} ) </i></span
            >
            <el-row
              :gutter="20"
              class="goodsCommentList"
              v-for="item in goodsCommentList"
              :key="item.bXyDoeid"
            >
              <el-col :span="4">
                <el-avatar :size="60" src="https://empty" @error="errorHandler">
                  <img :src="item.profile_photo" />
                </el-avatar>
                <span>{{ encryption(item.nickname, 2) }}</span>
              </el-col>
              <el-col :span="20">
                <p>
                  <el-rate disabled v-model="rateValue" show-text></el-rate>
                </p>
                <p class="goodsCommentList_content">{{ item.content }}</p>
                <el-image
                  class="commentListImg"
                  v-for="(imgItem, index) in item.images"
                  :src="imgItem"
                  :key="index"
                  :preview-src-list="[imgItem]"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="lastLine">
                  <div class="goodsCommentList_goodsName">
                    <p
                      class="goodsNameText OneLineDisplay"
                      :title="item.goodsName"
                    >
                      {{ item.goodsName }}
                    </p>
                    <!-- <span> {{item.bxmId}}</span> 商品属性 -->
                    <span style="margin-left: 20px">
                      {{ item.createTime }}</span
                    >
                  </div>
                  <div class="goodsCommentList_opreate">
                    <!-- 点赞，后续增加 -->
                    <!-- <span><img :src="require('@/assets/img/noLIke.png')" alt="" @click="likeHadle(item.bXyDoeid,item.likepoint)">( {{item.likepoint||0}} )</span> -->
                    <!-- <i @click="openReplayHadle(item.id)" class="el-icon-chat-dot-round"></i> -->
                    <i
                      @click="item.showRepalyBox = !item.showRepalyBox"
                      class="el-icon-chat-dot-round"
                    ></i>
                  </div>
                </div>
                <div class="repalyBox" v-show="item.showRepalyBox">
                  <el-input
                    placeholder="回复楼主"
                    v-model="replayContent"
                    class="goods_advisory_input"
                  >
                    <el-button
                      slot="append"
                      class="advisory_button"
                      @click="replayHandle(item.bXyDoeid)"
                      >回复</el-button
                    >
                  </el-input>
                </div>
                <!-- 某条评论下的回复 -->
                <div v-if="item.replyList.length > 0 ? true : false">
                  <div
                    class="replayBox"
                    v-for="(replayItem, index) in item.replyList"
                    :key="index"
                  >
                    <el-divider></el-divider>
                    <span :class="replayItem.type == 1 ? 'redColor' : ''"
                      >{{
                        replayItem.type == 1
                          ? replayItem.nickname
                          : encryption(replayItem.nickname, 2)
                      }}
                      回复：</span
                    >
                    <p
                      style="margin: 10px 0"
                      :class="replayItem.type == 1 ? 'redColor' : ''"
                    >
                      {{ replayItem.content }}
                    </p>
                    <div class="lastLine">
                      <div class="goodsCommentList_goodsName">
                        <div>{{ item.createTime }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div
              class="goods_advisory"
              v-if="goodsCommentList.length == 0 ? true : false"
            >
              暂无评价
            </div>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label" class="goodsTabs">
              商品咨询 <i>( {{ adviceLength }} )</i></span
            >
            <div class="goods_advisory">
              <el-input
                placeholder="请输入内容"
                v-model="inputContent"
                class="goods_advisory_input"
              >
                <el-button
                  slot="append"
                  class="advisory_button"
                  @click="advisoryHandle()"
                  >提问</el-button
                >
              </el-input>
            </div>
            <div class="goods_adviceList">
              <el-row
                v-for="item in goodsAdviceList"
                :key="item.bXyDaid"
                style="
                  margin-bottom: 20px;
                  padding: 15px;
                  border-bottom: 1px solid #dcdfe6;
                "
              >
                <el-col :span="12">
                  <span class="textRight askText">问</span>
                  <span class="textRight">{{ item.content }}</span>
                  <!-- <span class="textRight">点赞（{{ 11 }}）</span> -->
                </el-col>
                <el-col :span="12" class="goods_adviceList_right">
                  <span class="textRight">{{ item.name }}</span>
                  <span class="textRight">{{ item.createTime }}</span>
                </el-col>
                <el-col
                  :span="24"
                  style="margin-top: 10px"
                  v-if="item.bxyDealAdvisoryReplyList.length > 0 ? true : false"
                >
                  <el-row
                    v-for="item1 in item.bxyDealAdvisoryReplyList"
                    :key="item1.bXyDarid"
                  >
                    <el-col :span="12">
                      <span class="textRight askText">答</span>
                      <span class="textRight">{{ item1.content }}</span>
                      <!-- <span class="textRight">点赞（{{ 11 }}）</span> -->
                    </el-col>
                    <el-col :span="12" class="goods_adviceList_right">
                      <span class="textRight">{{ item.name }}</span>
                      <span class="textRight">{{ item1.createTime }}</span>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col
                  :span="24"
                  style="margin-top: 10px"
                  v-if="
                    item.bxyDealAdvisoryReplyList.length == 0 ? true : false
                  "
                >
                  <span class="textRight askText replayText">答</span>
                  <span>暂无回答</span>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label" class="goodsTabs"> 商家介绍</span>
            <span
              >上海宝丽妍贸易有限公司成立于2004年10月09日，注册地位于中国(上海)自由贸易试验区日京路35号凯兴大楼1028室，法定代表人为服部
              佑介(HATTORI
              YUSUKE)。经营范围包括国际贸易、转口贸易、区内企业间的贸易及贸易代理；区内贸易咨询业务；区内商业性简单加工；化妆品、食品、茶叶、饮料、卫生用品、调味品的批发、零售、佣金代理（拍卖除外）、进出口及其它相关配套业务；美容（限分支机构经营），美容管理及相关技术培训、咨询服务。
              【依法须经批准的项目，经相关部门批准后方可开展经营活动】上海宝丽妍贸易有限公司具有4处分支机构</span
            >
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog
      class="addCartBox"
      :visible.sync="becomeSupplierVisible"
      width="30%"
      center
    >
      <div style="text-align: center">
        <div class="addGoodsInfo">{{ tipContent }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getDistStatusClick()"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>

    <!-- 提问弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">提问成功</div>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="centerDialogVisible = false">继续购物</el-button> -->
          <el-button type="primary" @click="centerDialogVisible = false"
            >继续浏览</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="centerDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>

    <!-- 加入购物车弹框 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addDialogVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="successInfo">
        <div class="addGoodsInfo">已成功加入购物车！</div>
        <!-- <div>{{ addGoodsName }}</div> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">继续购物</el-button>
          <el-button
            type="primary"
            @click="$router.push('/shoppingcart_supplie')"
            >去购物车结算</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!successInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addDialogVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 加入购物车结束 -->

    <!-- 回复 开始 -->
    <el-dialog
      class="addCartBox"
      :visible.sync="addReplayVisible"
      width="30%"
      center
    >
      <div style="text-align: center" v-show="relaysuccessInfo">
        <div class="addGoodsInfo">评论成功,等待客服进行处理!</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addReplayVisible = false"
            >确定</el-button
          >
        </span>
      </div>
      <div style="text-align: center" v-show="!relaysuccessInfo">
        <div>需要登录</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addReplayVisible = false"
            >确定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 回复 结束 -->
  </div>
</template>
<script>
import magnifier from "@/components/magnifier"; // 放大镜
import { mapState, mapMutations } from "vuex";
import hotGoods from "@/components/hotGoods";
import shopStoreItem from "@/components/shopStoreItem";
import goodsSizeItem from "@/components/goodsSize"; // 商品规格
// import addressSelect from '@/components/addressSelect'
import "@/assets/css/goodsDetail/goodsDetail.css";
import {
  storeList,
  getAttributelist,
  getSpecificationDetail,
  commoditylist,
  addShoppingCart,
  getDistStatus,
  distributors_add,
  WholesaleGoods_add,
  area_list,
  removeCollection,
  addCollection,
  goodsAdvice,
  addgoodsAdvice,
  commentList,
  replayComment,
} from "@/api/xunyou";
import $ from "jquery";
// import
export default {
  data() {
    return {
      isSelectedImg: "",
      selected: false,
      selectedImgUrl: "", // 选择的图片路径
      isVedio:true, // 是否是视频
      bigphotos: "",
      videoUrl:'',
      moreImgArr: [],
      isshow: 1,
      userInfo: this.$store.state.userInfo,
      tipContent: "", // 分销提示
      isSupplier: 1, //1.未签约 2.已签约 3.一键分销
      addDialogVisible: false, //加入购物车弹框
      becomeSupplierVisible: false,
      goodsSize: 5,
      info: {},
      centerDialogVisible: false,
      successInfo: true,
      inputContent: "",
      hotGoodsTitle: "热卖商品",
      storeInfo: {
        shopName: "华为旗舰店",
        shopImg:
          "https://www.xunyoutest.com/image.php/shop/data/upload/media/store/8/image/20200722/1595385136199650.jpg",
        shopLink: "https://www.xunyoutest.com?ctl=Store&met=get&store_id=8",
        shopscore: "5.0",
        shopattitude: "4.9",
        shopspeed: "4.9",
      },
      lefthotGoodsList: [
        {
          id: "0",
          price: "1903.88",
          title: "POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫",
          link:
            "https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157",
          imgSrc:
            "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg",
        },
        {
          id: "1",
          price: "1903.88",
          title: "POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫",
          link:
            "https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157",
          imgSrc:
            "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg",
        },
        {
          id: "2",
          price: "1903.88",
          title: "POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫",
          link:
            "https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157",
          imgSrc:
            "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg",
        },
        {
          id: "3",
          price: "1903.88",
          title: "POLA/宝丽碧艾B.A 洁面膏100g温和清洁泡沫",
          link:
            "https://ceshi.xunyoutest.com?ctl=Product&amp;met=detail&amp;item_id=1157",
          imgSrc:
            "https://ceshi.xunyoutest.com/image.php/shop/data/upload/media/store/13/image/20200721/1595324748630659.jpg!268x268.jpg",
        },
      ],
      attributelist: [],
      specificationlist: [],
      goodsIdArr: [], // 选中的属性对象数组
      idArr: [], // 选中的属性id集合
      selectAttrId: "",
      num1: 1, //商品数量
      //  getprovince:[], // 地址联动
      cascaderAreaValue: [], // 发货地址
      shippingAreaValue: [], // 收货地址
      goodsAdviceList: [], // 商品咨询
      adviceLength: 0,
      commentLength: 0,
      //  顶部导航栏
      isTabActive: "0",
      isSelectedTab: 0,
      activeName: "0",
      searchBarFixed: false,
      topNav: [
        {
          id: 0,
          title: "商品详情",
          num: "",
        },
        {
          id: 1,
          title: "商品评价",
          num: "",
        },
        {
          id: 2,
          title: "商品咨询",
          num: "",
        },
        {
          id: 3,
          title: "商家介绍",
          num: "",
        },
      ],
      //  商品评价
      addReplayVisible: false,
      relaysuccessInfo: true,
      replayContent: "",
      rateValue: 5, // 商品评分
      // commentImgArr:[],
      goodsCommentList: [
        // {
        //   id:1,
        //   goodsName:"兰芝夜间修护睡眠面膜补水保湿涂抹式免洗女官方专柜正品滋润面部 70ml",
        //   bxmId:'属性字段',
        //   likepoint:3,
        //   createTime:'2020-05-09 12:00:02',
        //   images:'/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg',
        //   nickname: "电商用户",
        //   avatar: "/profile/upload/2021/01/06/75b704ff4d5df12811a9bc5197a85342.jpg",
        //   content: "nihaovvvvvvvvvvvvvvvvvv a ",
        //   rateValue:2.0,
        //   showRepalyBox:false,
        //   replyList:[
        //     {
        //       id:1,
        //       nickname: "电商用户",
        //       content: "nihao a ",
        //        createTime:'2020-05-09 11:00:02',
        //        images:'/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg',
        //     },
        //     {
        //       id:1,
        //       nickname: "电商用户",
        //       content: "nihao a ",
        //       createTime:'2020-05-09 11:00:02',
        //       images:'/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg,/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg',
        //     }
        //   ]
        // },
        // {
        //   id:2,
        //   goodsName:"兰芝夜间修护睡眠面膜补水",
        //   bxmId:'属性字段1',
        //   likepoint:3,
        //   createTime:'2020-05-09 11:00:02',
        //   images:'/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg,/profile/upload/2021/01/12/0fae9a7a34054f4c824fe71042b19bfe.jpg',
        //   nickname: "电商用户133",
        //   avatar: "/profile/upload/2021/01/06/75b704ff4d5df12811a9bc5197a85342.jpg",
        //   content: "nihaovvvvvvvvvvvvvvvvvv a ",
        //   rateValue:3.0,
        //   showRepalyBox:false,
        //   replyList:[]
        // }
      ],
    };
  },
  // 注册组件
  components: { hotGoods, shopStoreItem, magnifier, goodsSizeItem },
  computed: {
    ...mapState(["getprovince"]),
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getGoodsCommentList();
  },
  mounted() {
    this.getCommoditylistDetail();
    this.getCommoditylist();
    this.getGoodsAdvice();
    this.getAttributelists();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 顶部框选择
    topNavClick(tabId, index) {
      this.isTabActive = tabId;
      this.isSelectedTab = index;
      this.activeName = String(index);
    },
    // 滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log(scrollTop);
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector("#searchBar").offsetTop;
      if (scrollTop > 880) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },

    //   选择的图片
    selectedImg(url, index) {
      if(url.indexOf('mp4')>0||url.indexOf('avi')>0||url.indexOf('dat')>0||url.indexOf('3gp')>0||url.indexOf('mov')>0||url.indexOf('rmvb')>0){
         this.selected = true;
         this.isVedio = true
        this.isSelectedImg = index;
        this.selectedImgUrl = url
        // this.bigphotos = url
      }else{
        this.isVedio = false
        this.selected = true;
        this.isSelectedImg = index;
        this.selectedImgUrl = url;
        this.bigphotos = url;
      }
    },

    // 添加收藏
    addCollectionHandle(id) {
      if (this.userInfo.userId == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      // this.loading = true;
      const req = {
        type: 1, //1:商品；2：店铺；必填
        uid: this.userInfo.userId,
        cid: id, // 店铺id
      };
      addCollection(req)
        .then((res) => {
          if (res.code == 0) {
            this.getCommoditylistDetail();
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 取消收藏
    removeCollectionHandle(id) {
      // this.loading = true;
      const req = {
        type: 1, //1:商品；2：店铺；必填
        uid: this.userInfo.userId,
        cid: id, // 店铺id
      };
      removeCollection(req)
        .then((res) => {
          if (res.code == 0) {
            this.getCommoditylistDetail();
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },

    // 店铺查询
    searchStorerList(id) {
      this.loading = true;
      storeList({
        userId: this.userInfo.userId || "",
        bxmId: id,
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.storeInfo = res.rows[0];
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("店铺查询失败，请稍后再试！");
        });
    },
    // 填写地址选择
    areaHandleChange(value) {
      this.$refs["cascaderAddr"].getCheckedNodes();
      // this.ruleForm.areaid = value[value.length-1]
      // console.log(this.cascaderAreaValue,this.ruleForm.areaid,'填写地址选择');
    },

    // 获取商品规格
    getAttributelists() {
      getAttributelist({ productId: this.$route.query.id })
        .then((res) => {
          console.log("获取商品规格", res);
          if (res.code == 0) {
            this.attributelist = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("查询商品属性失败，请稍后再试！");
        });
    },

    // getDistStatus 获取商品状态
    getDistStatusClick() {
      getDistStatus({
        name: this.userInfo.loginName, // 登录用户的名字 info.id,info.mid
        mid: this.info.mid, // 商家id
        cid: this.info.id, // 产品id
      }) // 0.未签约 1.审核中 2.签约通过 3.审核驳回 4.商品未签约 5.已经分销 6.一键分销
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.isSupplier = res.data;
          this.becomeSupplierVisible = false;
        })
        .catch((err) => {
          this.$message.error("查询商品状态失败，请稍后再试！");
        });
    },

    // 申请成为分销商
    becomeSupplier() {
      if (this.isSupplier == 1) {
        this.tipContent = "正在审核中";
        this.becomeSupplierVisible = true;
        return;
      } else {
        distributors_add({
          mid2: this.info.mid, // 店铺id
          name: this.userInfo.loginName, // 用户名
        })
          .then((res) => {
            if (res.code == 0) {
              this.tipContent = "等待供应商审核 操作成功";
              this.becomeSupplierVisible = true;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error("查询商品列表失败，请稍后再试！");
          });
      }
    },

    // 一键分销
    oneClickDistribution() {
      // 一键分销之前先判断是否已有操作过
      WholesaleGoods_add({
        cid: this.info.id, // 商品id
        createBy: this.userInfo.loginName, // 分销商用户名
        distributors_id: this.userInfo.mid, // 分销商店铺id
        supplierId: this.info.mid //供应商id
      })
        .then((res) => {
          if (res.code == 0) {
            this.tipContent = "操作成功";
            this.becomeSupplierVisible = true;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },
    // 商品详情查询
    getCommoditylistDetail() {
      console.log("商品详情查询", this.$route.query.id);
      this.loading = true;
      commoditylist({
        id: this.$route.query.id,
        stype: "",
        userId: this.userInfo.userId || "",
      })
        .then((res) => {
          // console.log("res", res,res.data[0].mid);
          if (res.code == 0) {
            this.loading = false;
            this.info = res.rows[0];
            this.moreImgArr =
              res.rows[0].more_photos != null && res.rows[0].more_photos != ""
                ? res.rows[0].more_photos.split(",")
                : [];
            this.bigphotos =
            this.moreImgArr[0] != null ? this.moreImgArr[0] : "";
             if(res.rows[0].video==""||res.rows[0].video==null){
                  this.isVedio =false
                }else{
                  this.moreImgArr.unshift(res.rows[0].video)
                }
                this.videoUrl = res.rows[0].video;
            this.getDistStatusClick();
            this.searchStorerList(this.info.mid);
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },

    // 选规格价格发生变化s
    getgoodsSize(ids) {
      this.idArr = [];
      ids.forEach((item) => {
        this.idArr.push(item.id);
      });
      getSpecificationDetail({
        productId: this.$route.query.id,
        specificationIds: this.idArr.toString(),
      })
        .then((res) => {
          if (res.code == 0) {
            this.info.realprice =
              res.rows.length > 0 ? res.rows[0].price || 0 : 0;
            this.selectAttrId = res.rows.length > 0 ? res.rows[0].id || "" : "";
            this.specificationlist = res.rows.length > 0 ? res.rows : [];
            console.log(this.selectAttrId, "属性");
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("查询商品属性失败，请稍后再试！");
        });
      // this.info.realprice = value;
      // this.info.marketprice = value*this.info.number;
      // this.updateprice = updateprice;
    },
    // 加入购物车
    onAddCar(id, number, bXySid, status, approvalStatus) {

      if (this.userInfo.loginName == null || this.userInfo.loginName == "") {
        this.$router.push("/login");
        return;
      }
      if (status == 1 && approvalStatus == 1) {
        if (this.attributelist.length > 0) {
          if (this.selectAttrId == "") {
            this.$message({
              type: "info",
              message: "请选择规格",
            });
          }
        } else {
          this.selectAttrId = 0;
        }
        addShoppingCart({
          cid: id,
          uid: this.userInfo.userId,
          number: number,
          bxysid: this.selectAttrId,
        })
          .then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.addDialogVisible = true;
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("添加购物车失败，请稍后再试！");
          });
      } else {
        this.$message.error("暂时缺货");
        return;
      }
    },
    // 热卖商品列表查询
    getCommoditylist(id) {
      console.log("商品列表查询");
      this.loading = true;
      commoditylist({
        cid: id || "",
        stype: 1,
      })
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          this.lefthotGoodsList =
            res.rows > 4 ? res.rows.slice(0, 4) : res.rows;
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },
    // 计数量
    handleChange(value) {
      console.log(value);
      // this.info.marketprice = value*this.info.marketprice;
    },

    // 立即下单
    orderNow(status, approvalStatus) {
      if (status == 1 && approvalStatus == 1) {
        let selectList = [];
        let goodList = [];
        this.info.specificationlist = this.specificationlist;
        goodList.push({
          ...this.info,
        });
        let obj = {
          name: this.info.name,
          selectAttrId: this.selectAttrId,
          bxmId: this.info.mid,
          goods: goodList,
        };
        selectList.push(obj);
        sessionStorage.setItem("selectList", JSON.stringify(selectList));
        this.$router.push("/orderDetail?buyNow=true");
      } else {
        this.$message.error("暂时缺货");
        return;
      }
    },

    //   // // 放大镜开始
    // bigImgMove(){
    //     var mask = $('#mask');
    //     var bigBox = $('#bigbox');
    //     var bigImg = bigBox.children[0];
    // },
    // 放大镜结束

    // -------------- 切换tab 开始  -------------------------//
    //   切换tab
    tabhandleClick(tab, event) {
      this.isSelectedTab = this.activeName;
    },
    // -------------- 切换tab 结束 -------------------------//

    // -------------- 商品评价 开始 -------------------------//
    // 获取头像失败
    errorHandler() {
      return true;
    },
    //  个人信息加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 1);
        var newStrs = str.substring(str.length, str.length - 2);
        newStr = newStr + "****" + newStrs;
        return newStr;
      }
    },
    // 获取评价列表
    getGoodsCommentList() {
      commentList({
        goodId: this.$route.query.id,
        type:2,//1.店铺评级，2.商品评价
      })
        .then((res) => {
          if (res.code == 0) {
            this.goodsCommentList = res.rows;
            this.commentLength = this.goodsCommentList.length;
            this.goodsCommentList.forEach((item) => {
              this.rateValue =
                (item.matchScore + item.serviceScore + item.speedScore) / 3 ||
                0;
              item.isLike = false;
              item.images = item.images.split(",");
              item.images.forEach((imageItem, index) => {
                item.images[index] = `${imageItem}`;
              });
            });
          }
        })
        .catch((err) => {
          this.$message.error("查询商品评价失败，请稍后再试！");
        });
    },

    // 点赞
    likeHadle(id) {
      console.log("点赞", this.goodsCommentList);

      this.goodsCommentList.forEach((item) => {
        console.log(item.showRepalyBox, "jinlailwma");
        if (item.bXyDoeid == id && item.isLike == false) {
          item.likepoint = item.likepoint + 1;
          item.isLike = !item.isLike;
        } else if (item.bXyDoeid == id && item.isLike == true) {
          item.likepoint = item.likepoint == 0 ? 0 : item.likepoint - 1;
          item.isLike = !item.isLike;
        }
      });
    },
    openReplayHadle(id) {
      console.log(this.goodsCommentList, "打开");
      this.goodsCommentList.forEach((item) => {
        if (item.bXyDoeid == id) {
          item.showRepalyBox = !item.showRepalyBox;
        }
      });
      console.log(this.goodsCommentList, "jinlailwma");
    },
    // 回复
    replayHandle(id) {
      if (this.userInfo.userId == undefined) {
        this.$message.error("请登录！");
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
        return;
      }
      if (JSON.stringify(this.userInfo) == "{}") {
        this.relaysuccessInfo = false;
      }
      if (this.replayContent != "") {
        replayComment({
          bXyDoeid: id,
          uid: this.userInfo.userId,
          content: this.replayContent,
        })
          .then((res) => {
            if (res.code == 0) {
              this.getGoodsCommentList();
              this.replayContent = "";
              // this.addReplayVisible = true 后续若要审核，将这个弹框打开
            }
          })
          .catch((err) => {
            this.$message.error("回复评论失败，请稍后再试！");
          });
      } else {
        this.$message.error("请输入回复楼主内容");
      }
    },
    // -------------- 商品评价 开始 -------------------------//

    // -------------- 商品咨询 开始 -------------------------//
    getGoodsAdvice() {
      goodsAdvice({
        goodsId: this.$route.query.id || "",
      })
        .then((res) => {
          if (res.code == 0) {
            this.goodsAdviceList = res.rows;
            this.adviceLength = this.goodsAdviceList.length;
            console.log(this.goodsAdviceList, "商品咨询");
          }
        })
        .catch((err) => {
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },

    // 提问
    advisoryHandle() {
      if (this.inputContent == "") {
        this.$message({
          type: "info",
          message: "请输入提问内容",
        });
        return;
      }
      addgoodsAdvice({
        goodsId: this.$route.query.id || "",
        content: this.inputContent,
        uid: this.userInfo.userId,
      })
        .then((res) => {
          if (res.code == 0) {
            this.getGoodsAdvice();
            this.inputContent = "";
            this.centerDialogVisible = true;
          }
        })
        .catch((err) => {
          this.$message.error("查询商品列表失败，请稍后再试！");
        });
    },
    // -------------------- 商品咨询 结束 ----------------------------------//
  },
};
</script>

<style lang="less" scoped >
.breakcrumbHeader {
  margin: 15px 0;
}
.playBg{
  background: #958181;
  i.el-icon-video-play{
    color: #ddd;
  }
}
// 顶部导航栏
.pro-fixed_none {
  display: none;
  opacity: 0;
}
.pro-fixed-div {
  opacity: 100;
  transition: all 2s linear;
  padding: 0 332px;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid #ccc;
  left: 0;
  top: 0;
  background: #f7f8f8;
  height: 40px;
  z-index: 90;
  -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0 1px 5px 0;
  -moz-box-shadow: rgba(0, 0, 0, 0.2) 0 1px 5px 0;
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 5px 0;
  // .el-col-3{
  //   width: 10.5% !important;
  .topNav_shopName {
    height: 40px;
    width: 190px;
    padding: 10px;
    background: #ddd;
    box-sizing: border-box;
  }
  // }
  .toNav_goodsInfo {
    display: flex;
    background: #dddddd;
    height: 40px;
    .activeTab {
      color: white !important;
      background-color: #e4393c;
      border-right-color: #e4393c;
      border-left-color: #e4393c;
    }
    li.toNav_goodsInfoItem {
      padding: 0 20px;
      height: 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      line-height: 40px;
      display: inline-block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      position: relative;
      cursor: pointer;
    }
  }
}

.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

span.dettitle {
  color: #d33a31;
  line-height: 20px;
  font-weight: bold;
}
.tagadWord{
  font-size: 14px;
  color: #e30101;
  margin-bottom: 10px;
}
.tag{
  font-size: 14px;
  color: #d13030;
 margin-bottom: 10px;
  display: inline-block;
  border: 1px solid #d13030;
  border-radius: 4px;
  padding: 0 3px;
}
img#smallBox_img {
  width: 440px;
  height: 440px;
}
.closePrice_box {
  margin: 20px 0px;
  .closePrice_title {
    margin-bottom: 20px;
  }
  .closePrice {
    position: relative;
    bottom: -10px;
    color: #d33a31;
    font-size: 16px;
  }
  span.marketPrice_text {
    text-decoration: line-through;
    color: #ccc;
  }
}

//   规格按钮
.second-detail {
  /deep/.el-radio.is-bordered.is-checked {
    border-color: #d33a31;
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: #d33a31;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #d33a31;
    background: #d33a31;
  }
}

.twoButtom.el-row {
  margin-bottom: 20px;
  /deep/i.el-icon-star-on {
    color: #f12b2d;
    font-size: 18px;
    vertical-align: text-bottom;
  }
  /deep/i.el-icon-star-off {
    font-size: 18px;
    vertical-align: text-bottom;
  }
}

/* 商品Tabs项 */
.goodsTabs {
  font-size: 14px;
}
.goodsTabsr_card {
  /deep/.el-tabs__item {
    color: #555555;
  }
  /deep/.el-tabs__item.is-top.is-active {
    color: white !important;
    background-color: #e4393c !important;
    border-right-color: #e4393c !important;
    border-left-color: #e4393c !important;
  }
  /deep/.el-tabs__header {
    background-color: #ddd;
    border-bottom: 2px solid #e4393c;
  }
  /deep/.el-tabs__content {
    min-height: 500px;
    background: #f8f8f8;
  }
}

/** 商品详情 */
.goodsDetails {
  /deep/img {
    width: 100% !important;
  }
}

/** 商品评论 */
.goodsCommentList {
  padding: 15px;
  border-bottom: 1px solid #cccccc;
  .commentListImg {
    width: 60px;
    height: 60px;
    border: 1px solid #ccc;
    padding: 0px;
    margin: 10px;
  }
  /deep/span.el-rate__item {
    color: #e4393c !important;
  }
  /deep/span.el-avatar.el-avatar--circle {
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
    vertical-align: middle;
    margin-right: 10px;
  }
  /deep/.el-avatar > img {
    display: inline !important;
  }
  .goodsCommentList_content {
    font-size: 14px;
    margin-top: 10px;
  }
  .lastLine {
    display: flex;
    justify-content: space-between;
    .goodsCommentList_goodsName {
      color: #999;
      .goodsNameText {
        width: 260px;
        display: inline-block;
        vertical-align: top;
        margin-bottom: 10px;
      }
    }
    .goodsCommentList_opreate {
      span {
        color: #ccc;
        img {
          width: 25px;
          cursor: pointer;
        }
      }
      i.el-icon-chat-dot-round {
        font-size: 22px;
        vertical-align: sub;
        color: #ccc;
        margin-left: 15px;
        cursor: pointer;
      }
    }
  }
  .repalyBox {
    text-align: right;
    margin-top: 4px;
  }
  .redColor {
    color: #b30c0c;
  }
}

/* 商品咨询 */
.goods_advisory {
  text-align: center;
  font-size: 18px;
  // margin-top: 100px;
}
.goods_advisory_input {
  width: 50%;
}
.advisory_button {
  background: #e4393c !important;
  border: 1px solid #e4393c !important;
  color: white !important;
  border-radius: 0;
}
.goods_adviceList {
  margin-top: 20px;
  span.textRight {
    margin-right: 15px;
    font-size: 14px;
    color: #333;
    font-weight: 700;
  }
  .askText {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    font-size: 14px;
    color: #fff !important;
    text-align: center;
    /* float: left; */
    display: inline-block;
    background: #d13030;
  }
  .replayText {
    background: #00833d;
  }
  .goods_adviceList_right {
    text-align: right;

    span.textRight {
      color: #999;
      font-size: 14px;
    }
  }
}

/* 提问狂 */
.dialog-footer {
  margin-top: 20px;
  display: block;
}
.addGoodsInfo {
  font-size: 24px;
}
.addCartBox .el-button--primary {
  color: #fff;
  background-color: #ff6700;
  border-color: #e65d00;
}
.cascaderArea.el-cascader {
  /deep/input[disabled],
  /deep/input[disabled="disabled"],
  /deep/input[readonly],
  /deep/input[readonly="readonly"] {
    background-color: white;
  }
}
</style>







// WEBPACK FOOTER //
// src/views_supplier/goodsList/goodsDetail.vue